import React from 'react';
import { useEffect, useState } from "react";
import { getProductionDetails } from "../repositories/movies_and_tvseries";
import "../../styles/home/view_production_details.css";
import noImage from "../../images/collections/no_image.png";

const ViewProductionDetails = ({getShow, setShow, getProductionId}) => {
    const [getProductionImage, setProductionImage] = useState("");
    const [getProductionName, setProductionName] = useState("");
    const [getProductionDescription, setProductionDescription] = useState("");
    const [getProductionHeadquaters, setProductionHeadquaters] = useState("");
    const [getProductionOrigin, setProductionOrigin] = useState("");
    const [getProductionParent, setProductionParent] = useState("");
    const [getProductionHomePage, setProductionHomePage] = useState("");

    const viewUrl = (url) => {
        if (url !== "" || url != null) {
            window.open(url, '_blank');
        }
    }

    const retrieveProductionDetails = async () => {
        if (getProductionId !== "" || getProductionId != null) {
            const productionDetails = await getProductionDetails(getProductionId);
            setProductionImage(productionDetails["logo_path"] ?? "");
            setProductionName(productionDetails["name"] ?? "");
            setProductionDescription(productionDetails["description"] ?? "");
            setProductionHeadquaters(productionDetails["headquarters"] ?? "");
            setProductionOrigin(productionDetails["origin_country"] ?? "");
            setProductionParent(productionDetails["parent_company"] ?? "");
            setProductionHomePage(productionDetails["homepage"] ?? "");
        }
    }

    useEffect(() => {
        setProductionImage("");
        setProductionName("");
        setProductionDescription("");
        setProductionHeadquaters("");
        setProductionOrigin("");
        setProductionParent("");
        setProductionHomePage("");
        retrieveProductionDetails();
    }, [getProductionId]);

    return(
        <div className={`view_production_details ${getShow ? "show" : ""}`}>
            <div className="view_production_details_overlay" onClick={() => setShow(false)}></div>
            <div className="view_production_details_content">
                <div className="view_production_details_content_image_con">
                    <img className="view_production_details_content_image" alt={getProductionName} src={getProductionImage === "" || getProductionImage === null ? noImage : `https://image.tmdb.org/t/p/w500${getProductionImage}`} />
                </div>
                <p className="view_production_details_content_name">{getProductionName === "" || getProductionName === null ? "Unavailable" : getProductionName}</p>

                <div className="view_production_details_content_details_column">
                    {
                        getProductionDescription === "" || getProductionDescription === null
                        ? null
                        : <p className="view_production_details_content_description">{getProductionDescription}</p>
                    }

                    {
                        getProductionHeadquaters === "" || getProductionHeadquaters === null
                        ? null
                        : <div className="view_production_details_content_details_row">
                            <p className="view_production_details_content_subhead">Headquarters: </p>
                            <p className="view_production_details_content_details">{getProductionHeadquaters}</p>
                        </div>
                    }

                    {
                        getProductionOrigin === "" || getProductionOrigin === null
                        ? null
                        : <div className="view_production_details_content_details_row">
                            <p className="view_production_details_content_subhead">Country of Origin: </p>
                            <p className="view_production_details_content_details">{getProductionOrigin}</p>
                        </div>
                    }

                    {
                        getProductionParent === "" || getProductionParent === null
                        ? null
                        : <div className="view_production_details_content_details_row">
                            <p className="view_production_details_content_subhead">Parent Company: </p>
                            <p className="view_production_details_content_details">{getProductionParent}</p>
                        </div>
                    }

                    {
                        getProductionHomePage === "" || getProductionHomePage === null
                        ? null
                        : <div className="view_production_details_content_details_row">
                            <p className="view_production_details_content_subhead">Homepage: </p>
                            <p className="view_production_details_content_homepage" onClick={() => viewUrl(getProductionHomePage)}>{getProductionHomePage}</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default ViewProductionDetails;